var map = {
	"./1.png": "a854",
	"./10.png": "9cb3",
	"./2.png": "2949",
	"./3.png": "eb38",
	"./4.png": "1fc0",
	"./5.png": "7a78",
	"./6.png": "de37",
	"./7.png": "3774",
	"./8.png": "06f4",
	"./9.png": "97b6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31f7";